﻿
export default class HamburgerMenu {

    bodySelector = '[data-js-body]';
    headerSelector = '[data-js-header]';
    containerSelector = '[data-js-burger-menu]';
    menuSelector = '[data-js-modal-menu]';
    serviceMenuSelector = '[data-js-service-menu]';

    levelExpanderSelector = '[data-js-modal-menu-level-expander]';
    firstLevelExpanderSelector = '[data-js-modal-menu-level-expander-first]';
    toggleModalSelector = '[data-js-modal-menu-toggle]';

    levelSelector = '[data-js-modal-menu-level]';
    firstLevelSelector = '[data-js-modal-menu-level-first]';
    secondLevelSelector = '[data-js-modal-menu-level-second]';
    thirdLevelSelector = '[data-js-modal-menu-level-third]';

    levelItemSelector = '[data-js-modal-menu-level-item]'

    expandedAttr = '[aria-hidden=false]';

    modalVisibleClass = 'modal-is-visible';
    backgroundAnimationClass = 'menugroup-is-expanded';
    animateVisibilityClass = 'modal-content-is-visible';
    levelExpandedClass = 'modal-menu__level-is-expanded';
    levelItemVisibleClass = 'modal-menu__level__item-is-visible'

    mobileClass = 'is-mobile';

    isMobile = false;
    firstFocusableElement = null;
    lastFocusableElement = null;
    modalToggleElement = null;


    constructor() {
        this.setUpMenu();
        this.keyDownListener = this.keyDownListener.bind(this);
        this.checkResponsive();
        this.eventListener();
    }

    // get component 
    setUpMenu() {
        const container = document.querySelector(this.containerSelector);

        this.setUpToggleModal(container);
        this.setUpLevelToggle();
    }

    eventListener() {
        window.addEventListener('resize', (event) => {
            this.checkResponsive();
        })
    }

    checkResponsive(event) {
        const container = document.querySelector(this.containerSelector);
        const width = window.innerWidth;
        const body = document.querySelector(this.bodySelector);
        if (width < 768) {
            this.isMobile = true;
            body.classList.add(this.mobileClass);
            this.setUpMenuItems(container);

        } else {
            body.classList.remove(this.mobileClass);
            this.isMobile = false;
            this.setUpMenuItems(container);
        }
    }


    setUpMenuItems(element) {
        const firstLevelElement = document.querySelectorAll(this.firstLevelSelector);
        const secondLevelElement = document.querySelectorAll(this.secondLevelSelector);

        const firstLevelExpanderElement = document.querySelectorAll(this.firstLevelExpanderSelector);

        // check viewport and determine what levels should be open on load
        if (this.isMobile === false) {
            this.setUpDesktopView(firstLevelElement, secondLevelElement, firstLevelExpanderElement);

        } else {
            this.setUpMobileView(firstLevelElement, secondLevelElement, firstLevelExpanderElement);
        }

    }

    setUpDesktopView(firstLevelElement, secondLevelElement, firstLevelExpanderElement) {
        firstLevelExpanderElement.forEach(button => button.style.display = 'none');
        firstLevelExpanderElement.forEach(button => button.setAttribute('aria-expanded', 'true'));
        firstLevelElement.forEach(level => level.classList.add(this.levelExpandedClass));
        secondLevelElement.forEach(level => level.classList.add(this.levelExpandedClass));
        secondLevelElement.forEach(level => level.setAttribute('aria-hidden', 'false'));
    }


    setUpMobileView(firstLevelElement, secondLevelElement, firstLevelExpanderElement) {
        firstLevelExpanderElement.forEach(button => button.style.display = 'block');
        firstLevelExpanderElement.forEach(button => button.setAttribute('aria-expanded', 'false'));
        firstLevelElement.forEach(level => level.classList.add(this.levelExpandedClass))
        secondLevelElement.forEach(level => level.classList.remove(this.levelExpandedClass));
        secondLevelElement.forEach(level => level.setAttribute('aria-hidden', 'true'));
    }

    setUpLevelToggle() {
        const buttons = document.querySelectorAll(this.levelExpanderSelector);

        // set up buttons for toggling sub levels
        buttons.forEach(button => {

            button.addEventListener('click', (e) => {
                e.stopPropagation();
                e.preventDefault();

                // toggle sublevels
                const targetButton = e.target;
                const level = targetButton.nextElementSibling;
                const levelItems = level.querySelectorAll(this.levelItemSelector);

                if (this.isMobile === true) {
                    // if click on first level
                    if (targetButton.classList.contains('modal-menu__level__expander--first')) {
                        this.toggleFirstLevel(level, levelItems, targetButton);
                    } else {
                        if (targetButton.classList.contains('modal-menu__level__expander--second')
                            || (targetButton.classList.contains('modal-menu__level__expander--third'))) {
                            this.toggleSubLevels(level, levelItems, targetButton);
                        }
                    }
                } else {
                    this.toggleSubLevels(level, levelItems, targetButton);
                }
            });
        })
    }

    toggleSubLevels(level, levelItems, targetButton) {
        // set up for sub menu container transition height to auto
        level.style.height = '';
        level.style.transition = 'none';
        const startHeight = window.getComputedStyle(level).height;

        //toggle
        level.classList.toggle(this.levelExpandedClass);

        if (level.classList.contains(this.levelExpandedClass)) {
            level.setAttribute('aria-hidden', 'false');
            targetButton.setAttribute('aria-expanded', 'true');

            levelItems.forEach(item => item.classList.add(this.levelItemVisibleClass));

            this.animateHeight(level, startHeight);

        } else {
            level.setAttribute('aria-hidden', 'true');
            targetButton.setAttribute('aria-expanded', 'false');

            levelItems.forEach(item => item.classList.remove(this.levelItemVisibleClass));

            this.animateHeight(level, startHeight);
        }
    }


    // if mobile, only allow one level open at one time
    toggleFirstLevel(level, levelItems, targetButton) {
        // set up for sub menu container transition height to auto
        level.style.height = '';
        level.style.transition = 'none';
        const startHeight = window.getComputedStyle(level).height;

        const openedLevelElement = targetButton.nextElementSibling;
        const firstLevelElements = document.querySelectorAll(this.firstLevelSelector);
        const secondLevelElements = document.querySelectorAll(this.secondLevelSelector);

        const column = level.closest('.menugroup');

        if (openedLevelElement.classList.contains(this.levelExpandedClass)) {
            targetButton.setAttribute('aria-expanded', 'false');
            openedLevelElement.classList.remove(this.levelExpandedClass);
            openedLevelElement.setAttribute('aria-hidden', 'true');
            column.classList.remove(this.backgroundAnimationClass);

            this.animateHeight(level, startHeight);

        } else {
            targetButton.setAttribute('aria-expanded', 'true');
            openedLevelElement.classList.add(this.levelExpandedClass);
            openedLevelElement.setAttribute('aria-hidden', 'false');
            column.classList.add(this.backgroundAnimationClass);

            this.animateHeight(level, startHeight);
        }

        firstLevelElements.forEach(element => {
            if (targetButton.attributes['aria-expanded'].value === 'true') {
                targetButton.setAttribute('aria-expanded', 'true');
            }
        })

        secondLevelElements.forEach((element) => {
            if (element !== openedLevelElement) {
                element.classList.remove(this.levelExpandedClass);
                element.setAttribute('aria-hidden', 'true');

                const column = element.closest('.menugroup');
                column.classList.remove(this.backgroundAnimationClass);

                const buttons = document.querySelectorAll(this.firstLevelExpanderSelector);

                buttons.forEach(button => {
                    if (button && button !== targetButton && button.attributes['aria-expanded'].value === 'true') {
                        button.setAttribute('aria-expanded', 'false');
                    }
                })
            }
        })
    }

    animateHeight(level, startHeight) {
        // if sub menu is open, get height and start transition
        const height = window.getComputedStyle(level).height;
        level.style.height = startHeight;

        requestAnimationFrame(() => {
            level.style.transition = '';

            requestAnimationFrame(() => {
                level.style.height = height;
            })
        })

        level.addEventListener('transitionend', (func) => {
            level.style.height = '';
            level.removeEventListener('transitionend', func);
        });
    }


    // get menu toggle from main navigation
    setUpToggleModal(element, container) {
        const body = document.querySelector(this.bodySelector);
        this.modalToggleElement = element.querySelector(this.toggleModalSelector);

        this.modalToggleElement.addEventListener('click', () => {
            if (body.classList.contains(this.modalVisibleClass)) {
                this.hideModal();
                this.disableTrapFocus();
            } else {
                this.showModal();
                this.enableTrapFocus();
            }
        })
    }

    // trap focus in modal
    enableTrapFocus() {
        const focusableElements = 'button, [href]:not([data-js-service-menu-links] a)';
        const modal = document.querySelector('#modal-menu'); // select the modal by it's id
        const focusableContent = modal.querySelectorAll(focusableElements);

        this.firstFocusableElement = modal.querySelectorAll(focusableElements)[0]; // get first element to be focused inside modal
        this.lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside modal

        document.addEventListener('keydown', this.keyDownListener);
    }

    keyDownListener(e) {
        let isTabPressed = e.key === 'Tab' || e.keyCode === 9;

        if (!isTabPressed) {
            return;
        }

        if (e.shiftKey) { // if shift key pressed for shift + tab combination
            if (document.activeElement === this.firstFocusableElement) {
                this.modalToggleElement.focus(); // add focus for the last focusable element
                e.preventDefault();
            }
        } else { // if tab key is pressed
            if (document.activeElement === this.lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
                this.modalToggleElement.focus();
                e.preventDefault();
            }
        }
    }

    disableTrapFocus() {
        document.removeEventListener('keydown', this.keyDownListener);
    }


    // toggle menu modal
    showModal() {
        const body = document.querySelector(this.bodySelector);
        body.classList.add(this.modalVisibleClass);
        body.classList.add(this.animateVisibilityClass);

        //fix body to prevent scroll
        document.body.style.position = 'fixed';
        document.body.style.top = `-${window.scrollY}px`;   

        if (this.modalToggleElement) {
            this.modalToggleElement.setAttribute('aria-expanded', 'true');
        }
    }


    // toggle menu modal
    hideModal() {
        const body = document.querySelector(this.bodySelector);
        body.classList.remove(this.modalVisibleClass);
        body.classList.remove(this.animateVisibilityClass);

        const scrollY = document.body.style.top;
        document.body.style.position = '';
        document.body.style.top = '';
        window.scrollTo(0, parseInt(scrollY || '0') * -1);

        if (this.modalToggleElement) {
            this.modalToggleElement.setAttribute('aria-expanded', 'false');
        }
    }
}
